export function ImageCard({
  src,
  alt,
  headline,
  sub,
  overlayClassName,
  children,
}: {
  src: string;
  alt: string;
  headline: string;
  sub?: string;
  overlayClassName?: string;
  children?: React.ReactNode;
  sizes?: string;
}) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-gray-100 shadow-sm">
      <div className="relative aspect-video">
        <img
          src={src}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div
          className={`absolute inset-0 bg-gradient-to-t from-black/55 via-black/25 to-transparent${overlayClassName ? ` ${overlayClassName}` : ''}`}
        />
      </div>
      <div className="absolute inset-0 flex items-end">
        <div className="p-4">
          <h3 className="text-white text-lg font-semibold drop-shadow">
            {headline}
          </h3>
          {sub ? (
            <p className="text-white/85 text-sm drop-shadow">{sub}</p>
          ) : null}
        </div>
      </div>
      {children}
    </div>
  );
}
